<script setup>
import { ref, onMounted } from "vue";
import api from "@/api";
import { useRouter } from "vue-router";
import copyFailTip from "../common/copy_fail_tip.vue";

// 定义数据
const contractCount = ref(2);
const list = reactive({
  merchantCount: 0,
});

// 获取合同总数
// async function getContractCount() {
//   try {
//     const res = await api.get("/api/contract/count");
//     contractCount.value = res.data.count;
//   } catch (error) {
//     console.error("获取合同总数失败:", error);
//   }
// }

// 获取商家总数
function getIndex() {
  api
    .get("/api/regimental_commander/index")
    .then((res) => {
      list.merchantCount = res.data.merchant_total;
    })
    .catch((error) => {});
}
getIndex();

// // 初始化数据
// onMounted(() => {
//   getContractCount();
//   getMerchantCount();
// });

const copyFailTipRef = ref();
//获取商家邀请链接
function getMerchantUrl() {
  api
    .get("/api/merchant/join_url")
    .then((res) => {
      navigator.clipboard
        .writeText(res.data.url)
        .then(() => {
          ElMessage({
            message: "复制链接成功，链接只能注册一次且链接有效期7天",
            type: "success",
          });
        })
        .catch((err) => {
          copyFailTipRef.value.show(res.data);
          // ElMessage({
          //   message:
          //     "当前浏览器无权限复制，请更换浏览器复制或者开放浏览器复制权限",
          //   type: "error",
          // });
        });
    })
    .catch((error) => {});
}

// 路由
const router = useRouter();
</script>

<template>
  <div>
    <copyFailTip ref="copyFailTipRef" />
    <page-main>
      <el-scrollbar style="height: calc(100vh - 250px)">
        <div class="dashboard">
          <!-- <div class="card">
            <div class="card-header">商家合同总数</div>
            <div class="card-content">{{ contractCount }}</div>
            <div>
              <el-button
                type="primary"
                @click="
                  () => router.push('/merchant_manage/merchant_contract_index')
                "
                >前往商家合同页面</el-button
              >
            </div>
          </div> -->
          <div class="card">
            <div class="card-header">商家总数</div>
            <div class="card-content">{{ list.merchantCount }}</div>
            <div>
              <el-button
                type="primary"
                @click="() => router.push('/merchant_manage/merchant_index')"
                >前往商家页面</el-button
              >
              <el-button type="success" @click="getMerchantUrl"
                >邀请入驻</el-button
              >
            </div>
          </div>
        </div>
      </el-scrollbar>
    </page-main>
  </div>
</template>

<style scoped>
.dashboard {
  display: flex;
  padding: 20px;
  gap: 40px; /* 增加卡片之间的间距 */
  min-width: 960px;
}

.card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 33%;
  text-align: center;
  padding: 30px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.card-header {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.card-content {
  font-size: 32px;
  margin-bottom: 30px;
  color: #666;
}

/* .el-button {
  width: 100%;
  padding: 12px 20px;
  font-size: 16px;
} */
</style>
